module.exports = __webpack_public_path__ + "img/4.d1b9d19d.png";